import { Center, type CenterProps, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { TSurveyQuestion } from "@/types/surveys"
import { stringToColor } from "@/utils"

interface IProps extends CenterProps {
  question: TSurveyQuestion
}

export function QuestionImage({ question, ...props }: IProps) {
  const { t } = useTranslation()
  return (
    <Center
      {...props}
      style={{
        backgroundColor: stringToColor(question.category),
      }}
    >
      <Text c="white" fz="xl" fw={500} style={{ textTransform: "uppercase" }}>
        {t(question.category)}
      </Text>
    </Center>
  )
}
